export const CDR_EVENTS_TABLE = 'cdr-events-table';
